// extracted by mini-css-extract-plugin
export default {"container":"MG-z","header":"NG-z","details":"OG-z","link":"PG-z"};